module.exports = __webpack_public_path__ + "img/Truck.4a7f9f60.png";